<template>
  <Dialog 
    v-model:visible="visible" 
    header="Keyboard Shortcuts Reference" 
    :modal="true" 
    class="w-full max-w-md bg-slate-900 border border-slate-800 text-slate-100"
  >
    <div class="space-y-3 p-2 select-none text-xs">
      <div 
        v-for="sc in shortcuts" 
        :key="sc.key"
        class="flex items-center justify-between p-2.5 bg-slate-800/60 rounded-lg border border-slate-800"
      >
        <span class="text-slate-300 font-medium">{{ sc.label }}</span>
        <kbd class="px-2 py-1 bg-slate-950 border border-slate-700 rounded font-mono text-amber-400 font-semibold">
          {{ sc.key }}
        </kbd>
      </div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Dialog from 'primevue/dialog';

const props = defineProps<{
  visible: boolean;
}>();

const emit = defineEmits(['update:visible']);

const visible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val),
});

const shortcuts = [
  { key: 'Shift + Enter', label: 'Run Current Cell / Script in Pyodide' },
  { key: 'Ctrl + S / Cmd + S', label: 'Save Current Code Draft' },
  { key: 'Alt + B', label: 'Show / Hide Question Bank' },
  { key: 'Alt + O', label: 'Show / Hide Output Panel' },
  { key: 'Alt + N', label: 'Navigate to Next Question' },
  { key: 'Alt + P', label: 'Navigate to Previous Question' },
  { key: 'Esc', label: 'Close Active Modal / Overlay' },
];
</script>
